import { NavCloseIcon, OutlinedInfoIcon } from 'assets/icons';
import { CustomButton, CustomModal } from 'components';
import { FC } from 'react';
import { VoidFn } from 'types/baseTypes';
import { getAmountWithCurrency } from 'utils/amountUtils';
import { useKycLimitRevisionMessaging } from 'hooks/useKycLimitRevisionMessaging';

interface InvoiceLimitExceededPopupProps {
  onClose: VoidFn;
  invoiceLimits: {
    invoiceMinLimit: number | string;
    invoiceMaxLimit: number | string;
  };
  onEditInvoice: VoidFn;
}

const InvoiceLimitExceededPopup: FC<InvoiceLimitExceededPopupProps> = ({ onClose, invoiceLimits, onEditInvoice }) => {
  const { content, shouldShow } = useKycLimitRevisionMessaging();

  return (
    <CustomModal open={true} width="md:w-[335px]">
      <div className="relative">
        <div className="absolute right-4 top-4 cursor-pointer" onClick={onClose}>
          <NavCloseIcon />
        </div>
        <div className="flex flex-col items-center gap-3.5 p-4">
          <div className="flex h-16 w-16 shrink-0 items-center justify-center rounded-full bg-[#FFE5E5]">
            <OutlinedInfoIcon className="path-fill-current h-8 w-8 text-error" />
          </div>

          <div className="text-center text-17px font-semibold text-primaryText">Invoice Limit Exceeded</div>

          <div className="text-center text-sbase text-primaryText">
            Invoice total cannot exceed your current invoice limit (
            {getAmountWithCurrency(invoiceLimits.invoiceMaxLimit)}).
          </div>
          {shouldShow && content && (
            <div className="mt-2 text-center text-sbase text-primaryText">{content.oneLiner}</div>
          )}
        </div>
        <div className="m-4 mt-0">
          <CustomButton id="edit-invoice-btn" onClick={onEditInvoice} className="h-12 w-full">
            Edit invoice
          </CustomButton>
        </div>
      </div>
    </CustomModal>
  );
};

export default InvoiceLimitExceededPopup;
